import { compact } from 'lodash/fp';
import { createAction } from '@mews/framework';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { fetchCurrentEnterpriseReservationsByReservationIds } from '@mews-commander/legacy-entities/src/actions/reservations';
import { fetchCurrentEnterpriseTaskById } from '@mews-commander/legacy-entities/src/actions/tasks';
import { fetchCurrentEnterpriseDepartments } from '@mews-commander/legacy-entities/src/actions/departments';
import { RESERVATION_BARE_MINIMUM_EXTENT } from '../reservationModule/constants';
import { TASK_FORM_INIT_FAILED, TASK_FORM_INIT_STARTED, TASK_FORM_INIT_SUCCEEDED } from './actions/actionTypes';

interface TaskRouteParams {
    taskId?: string;
    serviceOrderId?: string;
}

export const prefetchTasks = async (dispatch: CommanderThunkDispatch, params?: TaskRouteParams) => {
    const fetchActions = compact([
        dispatch(fetchCurrentEnterpriseDepartments()),
        params?.taskId != null && dispatch(fetchCurrentEnterpriseTaskById(params.taskId)),
        params?.serviceOrderId != null &&
            dispatch(
                fetchCurrentEnterpriseReservationsByReservationIds({
                    reservationIds: [params.serviceOrderId],
                    extent: RESERVATION_BARE_MINIMUM_EXTENT,
                })
            ),
    ]);
    dispatch(createAction(TASK_FORM_INIT_STARTED));

    return Promise.all(fetchActions)
        .then(() => dispatch(createAction(TASK_FORM_INIT_SUCCEEDED)))
        .catch((e) => {
            dispatch(createAction(TASK_FORM_INIT_FAILED));
            throw e;
        });
};
